// Fire a Meta Pixel Standard event. Safe no-op if pixel isn't loaded yet.
// Events: Lead, ViewContent, Contact, CompleteRegistration, InitiateCheckout, etc.
// https://developers.facebook.com/docs/meta-pixel/reference
export function trackPixel(event, params = {}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq('track', event, params);
  } catch {
    // silently fail — pixel tracking must never break UX
  }
}
